import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidFogReading } from '../../../../mechanics/rid-fog-reading/rid-fog-reading';

@Component({
  selector: 'app-fog-reading-page',
  imports: [RidFogReading],
  templateUrl: './fog-reading-page.html',
})
export class FogReadingPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly pace = () => parseInt(this.$activatedRoute.snapshot.queryParams['pace'] ?? '200');
}
